// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Request from "../../core/Request.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as OrderRoutes from "./OrderRoutes.res.js";
import * as OrderStatus from "../../modules/Order/OrderStatus.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as SpinnerModal from "../../resources/feedback-indicators/SpinnerModal.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TableDateCell from "../../resources/tables/TableDateCell.res.js";
import * as Client from "@apollo/client";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as SupplierRoutes from "../Supplier/SupplierRoutes.res.js";
import * as AmountTableCell from "../../modules/TableCell/AmountTableCell.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as OrderStatusBadges from "../../modules/Order/OrderStatusBadges.res.js";
import * as OrderTableActions from "../../modules/Order/OrderTableActions.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderNameTableCell from "../../modules/Order/OrderNameTableCell.res.js";
import * as RequestOpenStorageUrl from "../../core/RequestOpenStorageUrl.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query OrderListPageQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputOrdersQueryFilter)  {\norders(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedName  \nshopName  \nsupplierCompanyName  \nissueDate  \nreceptionFinishedAt  \nestimatedReceptionDate  \nformattedStatus  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntotalProductsQuantity  \ntotalProductsExpectedQuantity  \nsupplier  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.orders;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    orders: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.receptionFinishedAt;
        let value$3 = value$1.formattedStatus;
        let value$4 = value$1.supplier;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            formattedName: value$1.formattedName,
            shopName: value$1.shopName,
            supplierCompanyName: value$1.supplierCompanyName,
            issueDate: Scalar.Datetime.parse(value$1.issueDate),
            receptionFinishedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
            estimatedReceptionDate: Scalar.Datetime.parse(value$1.estimatedReceptionDate),
            formattedStatus: value$3.map(value => {
              switch (value) {
                case "ACCEPTED" :
                  return "ACCEPTED";
                case "ARCHIVED" :
                  return "ARCHIVED";
                case "DRAFT" :
                  return "DRAFT";
                case "FINALIZED" :
                  return "FINALIZED";
                case "NOT_RECEIVED" :
                  return "NOT_RECEIVED";
                case "PAID" :
                  return "PAID";
                case "RECEIVED" :
                  return "RECEIVED";
                case "RECEIVING" :
                  return "RECEIVING";
                case "REFUSED" :
                  return "REFUSED";
                case "SENT" :
                  return "SENT";
                case "TO_PAY" :
                  return "TO_PAY";
                default:
                  throw {
                    RE_EXN_ID: "Not_found",
                    Error: new Error()
                  };
              }
            }),
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalProductsQuantity: value$1.totalProductsQuantity,
            totalProductsExpectedQuantity: value$1.totalProductsExpectedQuantity,
            supplier: !(value$4 == null) ? ({
                __typename: value$4.__typename,
                id: value$4.id
              }) : undefined
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.orders;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.supplier;
    let supplier;
    if (value$2 !== undefined) {
      let value$3 = value$2.id;
      let value$4 = value$2.__typename;
      supplier = {
        __typename: value$4,
        id: value$3
      };
    } else {
      supplier = null;
    }
    let value$5 = value$1.totalProductsExpectedQuantity;
    let value$6 = value$1.totalProductsQuantity;
    let value$7 = value$1.totalAmountIncludingTaxes;
    let value$8 = value$1.totalAmountExcludingTaxes;
    let value$9 = value$1.formattedStatus;
    let formattedStatus = value$9.map(value => {
      if (value === "TO_PAY") {
        return "TO_PAY";
      } else if (value === "DRAFT") {
        return "DRAFT";
      } else if (value === "NOT_RECEIVED") {
        return "NOT_RECEIVED";
      } else if (value === "REFUSED") {
        return "REFUSED";
      } else if (value === "FINALIZED") {
        return "FINALIZED";
      } else if (value === "ACCEPTED") {
        return "ACCEPTED";
      } else if (value === "PAID") {
        return "PAID";
      } else if (value === "RECEIVING") {
        return "RECEIVING";
      } else if (value === "SENT") {
        return "SENT";
      } else if (value === "RECEIVED") {
        return "RECEIVED";
      } else {
        return "ARCHIVED";
      }
    });
    let value$10 = value$1.estimatedReceptionDate;
    let value$11 = Scalar.Datetime.serialize(value$10);
    let value$12 = value$1.receptionFinishedAt;
    let receptionFinishedAt = value$12 !== undefined ? Scalar.Datetime.serialize(value$12) : null;
    let value$13 = value$1.issueDate;
    let value$14 = Scalar.Datetime.serialize(value$13);
    let value$15 = value$1.supplierCompanyName;
    let value$16 = value$1.shopName;
    let value$17 = value$1.formattedName;
    let value$18 = value$1.id;
    let value$19 = value$1.__typename;
    let node = {
      __typename: value$19,
      id: value$18,
      formattedName: value$17,
      shopName: value$16,
      supplierCompanyName: value$15,
      issueDate: value$14,
      receptionFinishedAt: receptionFinishedAt,
      estimatedReceptionDate: value$11,
      formattedStatus: formattedStatus,
      totalAmountExcludingTaxes: value$8,
      totalAmountIncludingTaxes: value$7,
      totalProductsQuantity: value$6,
      totalProductsExpectedQuantity: value$5,
      supplier: supplier
    };
    let value$20 = value.__typename;
    return {
      __typename: value$20,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let orders = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    orders: orders
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputOrdersQueryFilter(inp) {
  let a = inp.status;
  let a$1 = inp.createdAt;
  let a$2 = inp.issueDate;
  let a$3 = inp.receptionFinishedAt;
  let a$4 = inp.shopIds;
  return {
    status: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter(a$1) : undefined,
    issueDate: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    receptionFinishedAt: a$3 !== undefined ? serializeInputObjectDateFilter(a$3) : undefined,
    shopIds: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputOrdersQueryFilter(a$5) : undefined
  };
}

function makeVariables(search, before, after, first, last, filterBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy
  };
}

function makeInputObjectInputOrdersQueryFilter(status, createdAt, issueDate, receptionFinishedAt, shopIds, param) {
  return {
    status: status,
    createdAt: createdAt,
    issueDate: issueDate,
    receptionFinishedAt: receptionFinishedAt,
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputOrdersQueryFilter: serializeInputObjectInputOrdersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputOrdersQueryFilter: makeInputObjectInputOrdersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputOrdersQueryFilter: serializeInputObjectInputOrdersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputOrdersQueryFilter: makeInputObjectInputOrdersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

let make = React.memo(props => {
  let notification = props.notification;
  if (notification === undefined) {
    return null;
  }
  let onRequestClose = props.onRequestClose;
  let tmp;
  tmp = notification.TAG === "Ok" ? JsxRuntime.jsx(Banner.make, {
      textStatus: {
        TAG: "Success",
        _0: notification._0
      },
      onRequestClose: onRequestClose
    }) : JsxRuntime.jsx(Banner.make, {
      textStatus: {
        TAG: "Danger",
        _0: notification._0
      },
      onRequestClose: onRequestClose
    });
  return JsxRuntime.jsx(Box.make, {
    children: tmp,
    spaceTop: "medium"
  });
});

let NotificationBanner = {
  make: make
};

function MakeHistoryExportRequest(Config) {
  let encodeRequestBodyJson = (shopIds, status, orderIssueStartDate, orderIssueEndDate, orderReceptionFinishedStartDate, orderReceptionFinishedEndDate, param) => {
    let body = {};
    body["shopIds"] = Json.encodeArray(shopIds.map(Json.encodeString));
    if (status !== undefined) {
      body["status"] = Json.encodeString(OrderStatus.toString(status));
    }
    if (orderIssueStartDate !== undefined) {
      body["orderIssueStartDate"] = Json.encodeString(orderIssueStartDate.toISOString());
    }
    if (orderIssueEndDate !== undefined) {
      body["orderIssueEndDate"] = Json.encodeString(orderIssueEndDate.toISOString());
    }
    if (orderReceptionFinishedStartDate !== undefined) {
      body["orderReceptionFinishedStartDate"] = Json.encodeString(orderReceptionFinishedStartDate.toISOString());
    }
    if (orderReceptionFinishedEndDate !== undefined) {
      body["orderReceptionFinishedEndDate"] = Json.encodeString(orderReceptionFinishedEndDate.toISOString());
    }
    body["timeZone"] = Json.encodeString(I18n.timeZone);
    return Json.encodeDict(body);
  };
  let make = (shopIds, status, issueDateRange, receptionDateRange, param) => Request.make(Config.endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson(shopIds, status, Stdlib_Option.map(issueDateRange, prim => prim[0]), Stdlib_Option.map(issueDateRange, prim => prim[1]), Stdlib_Option.map(receptionDateRange, prim => prim[0]), Stdlib_Option.map(receptionDateRange, prim => prim[1]), undefined)
  }, undefined, undefined);
  let mapError = param => "UnexpectedFailure";
  let successMessage = I18n.template(I18n.t("The {{name}} file has been downloaded successfully."), {
    name: Config.exportName
  }, undefined);
  let messageFromError = error => I18n.template(I18n.t("An issue when attempting downloading the {{name}} file occurred."), {
    name: Config.exportName
  }, undefined);
  let useDownload = (shopIds, status, issueDateRange, receptionDateRange, param) => {
    let captureEvent = SessionTracker.useCaptureEvent();
    let request = () => {
      captureEvent(Config.eventName);
      return make(shopIds, status, issueDateRange, receptionDateRange, undefined);
    };
    let match = RequestOpenStorageUrl.use(request, undefined, undefined);
    let result = AsyncResult.mapError(match[0], mapError);
    return [
      result,
      match[1]
    ];
  };
  return {
    encodeRequestBodyJson: encodeRequestBodyJson,
    make: make,
    mapError: mapError,
    successMessage: successMessage,
    messageFromError: messageFromError,
    useDownload: useDownload
  };
}

let endpoint = Env.sheetUrl() + "/orders-history";

let exportName = I18n.t("orders");

function encodeRequestBodyJson(shopIds, status, orderIssueStartDate, orderIssueEndDate, orderReceptionFinishedStartDate, orderReceptionFinishedEndDate, param) {
  let body = {};
  body["shopIds"] = Json.encodeArray(shopIds.map(Json.encodeString));
  if (status !== undefined) {
    body["status"] = Json.encodeString(OrderStatus.toString(status));
  }
  if (orderIssueStartDate !== undefined) {
    body["orderIssueStartDate"] = Json.encodeString(orderIssueStartDate.toISOString());
  }
  if (orderIssueEndDate !== undefined) {
    body["orderIssueEndDate"] = Json.encodeString(orderIssueEndDate.toISOString());
  }
  if (orderReceptionFinishedStartDate !== undefined) {
    body["orderReceptionFinishedStartDate"] = Json.encodeString(orderReceptionFinishedStartDate.toISOString());
  }
  if (orderReceptionFinishedEndDate !== undefined) {
    body["orderReceptionFinishedEndDate"] = Json.encodeString(orderReceptionFinishedEndDate.toISOString());
  }
  body["timeZone"] = Json.encodeString(I18n.timeZone);
  return Json.encodeDict(body);
}

function make$1(shopIds, status, issueDateRange, receptionDateRange, param) {
  return Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson(shopIds, status, Stdlib_Option.map(issueDateRange, prim => prim[0]), Stdlib_Option.map(issueDateRange, prim => prim[1]), Stdlib_Option.map(receptionDateRange, prim => prim[0]), Stdlib_Option.map(receptionDateRange, prim => prim[1]), undefined)
  }, undefined, undefined);
}

function mapError(param) {
  return "UnexpectedFailure";
}

let successMessage = I18n.template(I18n.t("The {{name}} file has been downloaded successfully."), {
  name: exportName
}, undefined);

function messageFromError(error) {
  return I18n.template(I18n.t("An issue when attempting downloading the {{name}} file occurred."), {
    name: exportName
  }, undefined);
}

function useDownload(shopIds, status, issueDateRange, receptionDateRange, param) {
  let captureEvent = SessionTracker.useCaptureEvent();
  let request = () => {
    captureEvent("download_orders_export_file");
    return make$1(shopIds, status, issueDateRange, receptionDateRange, undefined);
  };
  let match = RequestOpenStorageUrl.use(request, undefined, undefined);
  let result = AsyncResult.mapError(match[0], mapError);
  return [
    result,
    match[1]
  ];
}

let OrdersHistoryExportRequest = {
  encodeRequestBodyJson: encodeRequestBodyJson,
  make: make$1,
  mapError: mapError,
  successMessage: successMessage,
  messageFromError: messageFromError,
  useDownload: useDownload
};

let endpoint$1 = Env.sheetUrl() + "/orders-products-history";

let exportName$1 = I18n.t("ordered products");

function encodeRequestBodyJson$1(shopIds, status, orderIssueStartDate, orderIssueEndDate, orderReceptionFinishedStartDate, orderReceptionFinishedEndDate, param) {
  let body = {};
  body["shopIds"] = Json.encodeArray(shopIds.map(Json.encodeString));
  if (status !== undefined) {
    body["status"] = Json.encodeString(OrderStatus.toString(status));
  }
  if (orderIssueStartDate !== undefined) {
    body["orderIssueStartDate"] = Json.encodeString(orderIssueStartDate.toISOString());
  }
  if (orderIssueEndDate !== undefined) {
    body["orderIssueEndDate"] = Json.encodeString(orderIssueEndDate.toISOString());
  }
  if (orderReceptionFinishedStartDate !== undefined) {
    body["orderReceptionFinishedStartDate"] = Json.encodeString(orderReceptionFinishedStartDate.toISOString());
  }
  if (orderReceptionFinishedEndDate !== undefined) {
    body["orderReceptionFinishedEndDate"] = Json.encodeString(orderReceptionFinishedEndDate.toISOString());
  }
  body["timeZone"] = Json.encodeString(I18n.timeZone);
  return Json.encodeDict(body);
}

function make$2(shopIds, status, issueDateRange, receptionDateRange, param) {
  return Request.make(endpoint$1, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson$1(shopIds, status, Stdlib_Option.map(issueDateRange, prim => prim[0]), Stdlib_Option.map(issueDateRange, prim => prim[1]), Stdlib_Option.map(receptionDateRange, prim => prim[0]), Stdlib_Option.map(receptionDateRange, prim => prim[1]), undefined)
  }, undefined, undefined);
}

function mapError$1(param) {
  return "UnexpectedFailure";
}

let successMessage$1 = I18n.template(I18n.t("The {{name}} file has been downloaded successfully."), {
  name: exportName$1
}, undefined);

function messageFromError$1(error) {
  return I18n.template(I18n.t("An issue when attempting downloading the {{name}} file occurred."), {
    name: exportName$1
  }, undefined);
}

function useDownload$1(shopIds, status, issueDateRange, receptionDateRange, param) {
  let captureEvent = SessionTracker.useCaptureEvent();
  let request = () => {
    captureEvent("download_orders_products_export_file");
    return make$2(shopIds, status, issueDateRange, receptionDateRange, undefined);
  };
  let match = RequestOpenStorageUrl.use(request, undefined, undefined);
  let result = AsyncResult.mapError(match[0], mapError$1);
  return [
    result,
    match[1]
  ];
}

let OrdersProductsHistoryExportRequest = {
  encodeRequestBodyJson: encodeRequestBodyJson$1,
  make: make$2,
  mapError: mapError$1,
  successMessage: successMessage$1,
  messageFromError: messageFromError$1,
  useDownload: useDownload$1
};

function OrderListPage$OrderListMorePageMenuActions(props) {
  let onRequestNotification = props.onRequestNotification;
  let receptionDateRange = props.receptionDateRange;
  let issueDateRange = props.issueDateRange;
  let status = props.status;
  let shopIds = props.shopIds;
  let match = useDownload(shopIds, status, issueDateRange, receptionDateRange, undefined);
  let requestOrdersDownload = match[1];
  let ordersResult = match[0];
  let match$1 = useDownload$1(shopIds, status, issueDateRange, receptionDateRange, undefined);
  let requestOrdersProductsHistoryDownload = match$1[1];
  let ordersProductsHistoryResult = match$1[0];
  React.useEffect(() => {
    if (typeof ordersResult === "object" && ordersResult.TAG === "Done") {
      let error = ordersResult._0;
      if (error.TAG === "Ok") {
        onRequestNotification({
          TAG: "Ok",
          _0: successMessage
        });
      } else {
        onRequestNotification({
          TAG: "Error",
          _0: messageFromError(error._0)
        });
      }
    }
  }, [AsyncResult.isDone(ordersResult)]);
  React.useEffect(() => {
    if (typeof ordersProductsHistoryResult === "object" && ordersProductsHistoryResult.TAG === "Done") {
      let error = ordersProductsHistoryResult._0;
      if (error.TAG === "Ok") {
        onRequestNotification({
          TAG: "Ok",
          _0: successMessage$1
        });
      } else {
        onRequestNotification({
          TAG: "Error",
          _0: messageFromError$1(error._0)
        });
      }
    }
  }, [AsyncResult.isDone(ordersProductsHistoryResult)]);
  let disabled = shopIds.length === 0;
  let spinnerModalTitle = AsyncData.isBusy(ordersResult) ? I18n.t("Export orders") : (
      AsyncData.isBusy(ordersProductsHistoryResult) ? I18n.t("Export ordered products") : ""
    );
  let spinnerModalOpened = AsyncData.isBusy(ordersResult) || AsyncData.isBusy(ordersProductsHistoryResult);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(SpinnerModal.make, {
        title: spinnerModalTitle,
        opened: spinnerModalOpened
      }),
      JsxRuntime.jsx(MenuActions.make, {
        children: JsxRuntime.jsxs(MenuActions.Section.make, {
          children: [
            JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Export orders"),
              icon: "export",
              onAction: () => requestOrdersDownload()
            }, "orders"),
            JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Export ordered products"),
              icon: "export",
              onAction: () => requestOrdersProductsHistoryDownload()
            }, "products")
          ]
        }),
        trigger: {
          TAG: "Normal",
          label: I18n.t("Actions"),
          size: "legacy_large"
        },
        disabledKeys: disabled ? [
            "orders",
            "products"
          ] : []
      })
    ]
  });
}

let OrderListMorePageMenuActions = {
  MakeHistoryExportRequest: MakeHistoryExportRequest,
  OrdersHistoryExportRequest: OrdersHistoryExportRequest,
  OrdersProductsHistoryExportRequest: OrdersProductsHistoryExportRequest,
  make: OrderListPage$OrderListMorePageMenuActions
};

let statuses = [
  "DRAFT",
  "FINALIZED",
  "ACCEPTED",
  "RECEIVING",
  "RECEIVED",
  "TO_PAY",
  "PAID",
  "ARCHIVED"
];

function encoder(param) {
  return [
    Stdlib_Option.map(param.shop, shop => shop.id),
    Stdlib_Option.map(param.status, OrderStatus.toString),
    Stdlib_Option.map(param.issueDateRange, param => [
      param[0].getTime(),
      param[1].getTime()
    ]),
    Stdlib_Option.map(param.receptionDateRange, param => [
      param[0].getTime(),
      param[1].getTime()
    ])
  ];
}

function decoder(shops, param) {
  let shopId = param[0];
  return {
    TAG: "Ok",
    _0: {
      shop: shops.find(shop => shop.id === shopId),
      status: Stdlib_Option.map(param[1], OrderStatus.fromStringExn),
      issueDateRange: Stdlib_Option.flatMap(param[2], range => {
        if (range.length !== 2) {
          return;
        }
        let start = range[0];
        let end = range[1];
        return [
          new Date(start),
          new Date(end)
        ];
      }),
      receptionDateRange: Stdlib_Option.flatMap(param[3], range => {
        if (range.length !== 2) {
          return;
        }
        let start = range[0];
        let end = range[1];
        return [
          new Date(start),
          new Date(end)
        ];
      })
    }
  };
}

function useJsonCodec() {
  let shops = Auth.useShops();
  return JsonCodec.object4(encoder, arg => decoder(shops, arg), JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("status", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("issueDateRange", JsonCodec.array(JsonCodec.float))), JsonCodec.optional(JsonCodec.field("receptionDateRange", JsonCodec.array(JsonCodec.float))));
}

let Filters = {
  statuses: statuses,
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

let Row = {};

function makeQueryVariables(_defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    search: search,
    before: connectionArguments.before,
    after: connectionArguments.after,
    first: connectionArguments.first,
    last: connectionArguments.last,
    filterBy: filterBy
  };
}

function makeQueryVariablesFilterBy(param) {
  let receptionDateRange = param.receptionDateRange;
  let issueDateRange = param.issueDateRange;
  let shop = param.shop;
  let status = Stdlib_Option.map(param.status, OrderStatus.toString);
  return {
    status: status !== undefined ? ({
        _in: [status]
      }) : undefined,
    createdAt: undefined,
    issueDate: issueDateRange !== undefined ? ({
        _after: undefined,
        _before: undefined,
        _between: [
          Scalar.Datetime.serialize(issueDateRange[0]),
          Scalar.Datetime.serialize(issueDateRange[1])
        ]
      }) : undefined,
    receptionFinishedAt: receptionDateRange !== undefined ? ({
        _after: undefined,
        _before: undefined,
        _between: [
          Scalar.Datetime.serialize(receptionDateRange[0]),
          Scalar.Datetime.serialize(receptionDateRange[1])
        ]
      }) : undefined,
    shopIds: shop !== undefined ? ({
        _in: [shop.id]
      }) : undefined
  };
}

function totalCountFromQueryData(param) {
  return param.orders.totalCount;
}

function cursorsFromQueryData(param) {
  let orders = param.orders;
  return [
    orders.pageInfo.startCursor,
    orders.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  return param.orders.edges.map(edge => ({
    id: edge.node.id,
    formattedName: edge.node.formattedName,
    shopName: edge.node.shopName,
    supplierCompanyName: edge.node.supplierCompanyName,
    supplierId: Stdlib_Option.map(edge.node.supplier, supplier => supplier.id),
    issueDate: edge.node.issueDate,
    receptionFinishedAt: edge.node.receptionFinishedAt,
    estimatedReceptionDate: edge.node.estimatedReceptionDate,
    statuses: edge.node.formattedStatus,
    totalAmountExcludingTaxes: edge.node.totalAmountExcludingTaxes,
    totalAmountIncludingTaxes: edge.node.totalAmountIncludingTaxes,
    totalProductsQuantity: edge.node.totalProductsQuantity,
    totalProductsExpectedQuantity: edge.node.totalProductsExpectedQuantity
  }));
}

function keyExtractor(param) {
  return param.id;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

function makeFromState(param) {
  let filters = param.filters;
  let shopId = Stdlib_Option.map(filters.shop, param => param.id);
  return {
    shopId: shopId,
    status: filters.status,
    issueDateRange: filters.issueDateRange,
    receptionDateRange: filters.receptionDateRange
  };
}

let SheetExportInput = {
  makeFromState: makeFromState
};

function OrderListPage(props) {
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let authScope = Auth.useScope();
  let match = Auth.useScope();
  let organisationAccount;
  organisationAccount = match.TAG === "Organisation";
  let initialFilters = {
    shop: activeShop,
    status: undefined,
    issueDateRange: undefined,
    receptionDateRange: undefined
  };
  let initialState = Scaffolded.makeInitialState(initialFilters);
  let match$1 = Scaffolded.use(() => initialState);
  let dispatch = match$1[1];
  let state = match$1[0];
  let defaultQueryVariables = {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined
  };
  let match$2 = React.useState(() => {});
  let setNotification = match$2[1];
  let columns = [
    {
      name: I18n.t("Number"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "pct",
          VAL: 20
        },
        margin: "normal",
        sticky: true
      },
      render: param => {
        let shopName;
        shopName = authScope.TAG === "Organisation" && authScope.activeShop === undefined ? param.shopName : undefined;
        return JsxRuntime.jsx(OrderNameTableCell.make, {
          value: param.formattedName,
          shopName: shopName,
          id: param.id
        });
      }
    },
    {
      name: I18n.t("Supplier"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "pct",
          VAL: 20
        },
        margin: "small"
      },
      render: param => {
        let supplierId = param.supplierId;
        if (supplierId !== undefined) {
          return JsxRuntime.jsx(TextLink.make, {
            text: param.supplierCompanyName,
            to: {
              TAG: "Route",
              _0: SupplierRoutes.showRoute(supplierId)
            }
          });
        } else {
          return null;
        }
      }
    },
    {
      name: I18n.t("Amount VAT excl."),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        sticky: true
      },
      render: param => JsxRuntime.jsx(AmountTableCell.make, {
        value: param.totalAmountExcludingTaxes,
        secondaryValue: param.totalAmountIncludingTaxes,
        decimalPrecision: 3
      })
    },
    {
      name: I18n.t("Issue date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => JsxRuntime.jsx(TableDateCell.make, {
        value: param.issueDate
      })
    },
    {
      name: I18n.t("Reception date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => {
        let receptionFinishedAt = param.receptionFinishedAt;
        if (receptionFinishedAt !== undefined) {
          return JsxRuntime.jsx(TableDateCell.make, {
            value: receptionFinishedAt
          });
        } else {
          return JsxRuntime.jsx(TableDateCell.make, {
            value: param.estimatedReceptionDate,
            label: I18n.t("estimated")
          });
        }
      }
    },
    {
      name: I18n.t("Rec. qt"),
      layout: {
        width: {
          NAME: "px",
          VAL: 100
        },
        margin: "xxlarge",
        alignX: "center"
      },
      render: param => {
        let statuses = param.statuses;
        return JsxRuntime.jsxs(Inline.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: OrderStatus.has(statuses, "RECEIVING") || OrderStatus.has(statuses, "RECEIVED") || OrderStatus.has(statuses, "ARCHIVED") ? param.totalProductsQuantity.toString() : "—",
              weight: "semibold",
              wrap: false
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: " / " + param.totalProductsExpectedQuantity.toString(),
              wrap: false
            })
          ]
        });
      }
    },
    {
      name: I18n.t("Status"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        },
        width: {
          NAME: "fr",
          VAL: 1.3
        }
      },
      render: param => JsxRuntime.jsx(OrderStatusBadges.make, {
        statuses: param.statuses
      })
    },
    {
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 70
        },
        width: {
          NAME: "px",
          VAL: 70
        },
        alignX: "flexEnd",
        sticky: true
      },
      render: param => JsxRuntime.jsx(Offset.make, {
        children: JsxRuntime.jsx(OrderTableActions.make, {
          id: param.id,
          name: param.formattedName,
          statuses: param.statuses,
          callbackUrlAfterArchiveAction: OrderRoutes.baseRoute,
          onRequestNotification: notification => setNotification(param => notification)
        }),
        right: -2,
        width: 32,
        height: 32
      })
    }
  ];
  let defaultItem_1 = I18n.t("Not archived");
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined
  };
  let items = statuses.map(status => ({
    TAG: "Option",
    key: OrderStatus.toString(status),
    label: OrderStatus.toLabel(status),
    value: status
  }));
  let match$3 = state.filters;
  let tmp;
  let exit = 0;
  if (match$3.status !== undefined || match$3.issueDateRange !== undefined || match$3.receptionDateRange !== undefined) {
    exit = 1;
  } else {
    tmp = null;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Scaffold.ResetFiltersButton.make, {
      onPress: () => dispatch({
        TAG: "FiltersUpdated",
        _0: param => initialState.filters
      })
    });
  }
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      organisationAccount ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
          value: state.filters.shop,
          onChange: shop => dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: shop,
              status: prev.status,
              issueDateRange: prev.issueDateRange,
              receptionDateRange: prev.receptionDateRange
            })
          })
        }) : null,
      organisationAccount ? JsxRuntime.jsx(CanarySeparator.make, {}) : null,
      JsxRuntime.jsx(Select.make, {
        label: I18n.t("Status"),
        preset: "filter",
        renderValue: param => {
          let selectedItems = param.selectedItems;
          if (selectedItems.length === 1) {
            let match = selectedItems[0];
            if (match.TAG === "Option") {
              let status = match.value;
              if (status !== undefined) {
                return OrderStatusBadges.toBadge(status);
              }
            }
          }
          return JsxRuntime.jsx("span", {
            children: I18n.t("Not archived")
          });
        },
        renderItem: param => {
          let item = param.item;
          if (item.TAG !== "Option") {
            return null;
          }
          let status = item.value;
          if (status !== undefined) {
            return JsxRuntime.jsx(Inline.make, {
              children: OrderStatusBadges.toBadge(status),
              grow: false
            });
          } else {
            return JsxRuntime.jsx("span", {
              children: I18n.t("Not archived")
            });
          }
        },
        sections: [
          {
            items: [defaultItem]
          },
          {
            items: items,
            title: I18n.t("Statuses")
          }
        ],
        value: {
          TAG: "Single",
          _0: state.filters.status
        },
        onChange: change => {
          if (change.TAG !== "Single") {
            return;
          }
          let status = change._0;
          dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: prev.shop,
              status: status,
              issueDateRange: prev.issueDateRange,
              receptionDateRange: prev.receptionDateRange
            })
          });
        }
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.issueDateRange,
        label: I18n.t("Issue"),
        placeholder: "",
        onChange: issueDateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            status: prev.status,
            issueDateRange: issueDateRange,
            receptionDateRange: prev.receptionDateRange
          })
        }),
        triggerLabelDisplay: "showPreset"
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.receptionDateRange,
        label: I18n.t("Reception"),
        placeholder: "",
        onChange: receptionDateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            status: prev.status,
            issueDateRange: prev.issueDateRange,
            receptionDateRange: receptionDateRange
          })
        }),
        triggerLabelDisplay: "showPreset"
      }),
      tmp
    ],
    space: "small"
  });
  let match$4 = makeFromState(state);
  let shopId = match$4.shopId;
  let shopIds = shopId !== undefined ? [shopId] : shops.map(shop => shop.id);
  let actions = JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(OrderListPage$OrderListMorePageMenuActions, {
        shopIds: shopIds,
        status: match$4.status,
        issueDateRange: match$4.issueDateRange,
        receptionDateRange: match$4.receptionDateRange,
        onRequestNotification: notification => setNotification(param => notification)
      }),
      JsxRuntime.jsx(Button.make, {
        label: I18n.t("New order"),
        variant: "solid",
        tone: "brand",
        size: "legacy_large",
        href: OrderRoutes.createRoute
      })
    ],
    space: "small"
  });
  let banner = JsxRuntime.jsx(make, {
    notification: match$2[0],
    onRequestClose: () => setNotification(param => {})
  });
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search an order"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let emptyState;
  let exit$1 = 0;
  if (state.currentPage !== 1 || state.searchQuery !== undefined) {
    exit$1 = 1;
  } else {
    let match$5 = state.filters;
    if (match$5.status !== undefined || match$5.issueDateRange !== undefined || match$5.receptionDateRange !== undefined || match$5.shop !== activeShop) {
      exit$1 = 1;
    } else {
      emptyState = JsxRuntime.jsx(EmptyState.make, {
        illustration: Illustration.create,
        title: I18n.t("Welcome to the supplier orders space.")
      });
    }
  }
  if (exit$1 === 1) {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  return JsxRuntime.jsx(Scaffolded.make, {
    title: I18n.t("Supplier orders"),
    state: state,
    dispatch: dispatch,
    columns: columns,
    filters: filters,
    actions: actions,
    banner: banner,
    searchBar: searchBar,
    emptyState: emptyState,
    defaultQueryVariables: defaultQueryVariables
  });
}

let make$3 = React.memo(OrderListPage);

export {
  Query,
  NotificationBanner,
  OrderListMorePageMenuActions,
  Filters,
  Row,
  Scaffolded,
  SheetExportInput,
  make$3 as make,
}
/* query Not a pure module */
